import { render, staticRenderFns } from "./OpdForm.vue?vue&type=template&id=fb4c10ec"
import script from "./OpdForm.vue?vue&type=script&lang=js"
export * from "./OpdForm.vue?vue&type=script&lang=js"
import style0 from "./OpdForm.vue?vue&type=style&index=0&id=fb4c10ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports